(function () {
    function getHeight(el) {
        return el ? el.offsetHeight : 0;
    }

    function scrollCoverToEnd() {
        const cover = document.querySelector('.asset-cover');
        if (!cover) return;

        const coverBottom = cover.getBoundingClientRect().bottom + window.scrollY;
        window.scrollTo({
            top: coverBottom,
            behavior: 'smooth'
        });
    }

    function init() {
        const cover = document.querySelector('.asset-cover');
        if (!cover) return;

        const topbar = document.getElementById('site-top-bar-container');
        const header = document.getElementById('site-header-container');
        const navbar = document.getElementById('site-navbar-container');

        const usedHeight = getHeight(topbar) + getHeight(header) + getHeight(navbar);
        let coverHeight = window.innerHeight - usedHeight;

        if (coverHeight < window.innerHeight/2) coverHeight = 800;

        cover.style.height = coverHeight + 'px';

        const scrollButton = cover.querySelector('.scroll-button');
        if (scrollButton) {
            scrollButton.addEventListener('click', scrollCoverToEnd);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();